import { Component, OnInit } from '@angular/core';
import { UserLogService } from '../../services/user-log.service';

@Component({
  selector: 'app-cell-user-statistics',
  templateUrl: './cell-user-statistics.component.html',
  styleUrls: ['./cell-user-statistics.component.scss']
})
export class CellUserStatisticsComponent implements OnInit {

  public authId: any;
  public tipoLog: any;

  public valor: any;

  constructor(private _UserLogService: UserLogService) {}

  agInit(params: any): void {
    this.authId = params.value;
    this.tipoLog = params.tipoLog;
  }

  ngOnInit() {
    if (this.tipoLog == 1) {
      this._UserLogService.mesEnCurso(this.authId).subscribe((x: any) => { this.valor = x; });
    }
    else if (this.tipoLog == 0) {
      this._UserLogService.diaEnCurso(this.authId).subscribe((x: any) => { this.valor = x; });
    }
    else if (this.tipoLog == 2) {
      this._UserLogService.mesPasado(this.authId).subscribe((x: any) => { this.valor = x; });
    }
  }

}
